import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import LogoutModel from "../../components/Models/LogoutModel";
import TabsComponent from "../../components/home/TabsComponent";
import actions from "../../redux/actions";
import MyChangePasswordModal from "../../components/Models/MyChangePasswordModal";
import {
  isRoleExits,
  isSuperAdmin,
  showForAllExceptManager,
} from "../../utils";

const Dashboard = () => {
  useEffect(() => {
    const fetchData = () => {
      // if (isRoleExits("matka")) {
      // } else {
      actions.GetMarkerAnalysis();
      // }
    };
    fetchData();
    const intervalId = setInterval(fetchData, 30000);
    return () => clearInterval(intervalId);
  }, [actions]);

  return (
    <div>
      <>
        <div id="wrapper">
          <Sidebar />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Navbar navTitle={"Dashboard"} />
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>
                <TabsComponent />
              </div>
            </div>
            <Footer />
          </div>
        </div>

        <LogoutModel />
        <MyChangePasswordModal />
      </>
    </div>
  );
};

export default Dashboard;
